import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MeetingSearchModel } from '../models/meeting/MeetingSearchModel';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'public/environments/environment';
import { AddMeeting } from '../models/meeting/AddMeeting';
import { SubmitMeetingInvitaion } from '../models/meeting/SubmitMeetingInvitaion';
@Injectable({
  providedIn: 'root'
})
export class MeetingsService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) { }

  getListInviteeMeetings(searchModel: MeetingSearchModel): any {
    return this.http.post(`${environment.apiUrl}/Meetings/ListInviteeMeetings`, searchModel);
  }
  GetUserGroups() {
    return this.http.get(`${environment.apiUrl}/Meetings/GetUserGroups`);
  }
  GetLiveMeetings() {
    return this.http.get(`${environment.apiUrl}/Meetings/GetLiveMeetings`);
  }
  GetInviteesToDelegate(meetingId) {
    return this.http.get(`${environment.apiUrl}/meetingInvitees/GetInviteesToDelegate/` + meetingId);
  }
  SubmitMeetingInvitaion(SubmitMeetingInvitaionObj: SubmitMeetingInvitaion): any {
    return this.http.post(`${environment.apiUrl}/meetingInvitees/SubmitMeetingInvitaion`, SubmitMeetingInvitaionObj);
  }
  getListMeetings() {
    return this.http.get(`${environment.apiUrl}/Meetings/ListMeetings`);
  }
  GetGroupCollectionAndUsers(groupId, searchText = null) {
    if (searchText != null && searchText != "") {
      return this.http.get(`${environment.apiUrl}/Meetings/GetGroupCollectionAndUsers/` + groupId + '?searchText=' + searchText);
    } else {
      return this.http.get(`${environment.apiUrl}/Meetings/GetGroupCollectionAndUsers/` + groupId);
    }
  }

  AddMeeting(AddMeetingObj: AddMeeting): any {
    const formData = new FormData();
    AddMeetingObj.agendaItems.forEach((element: any, index) => {
      element.files.forEach(file => {
        formData.append(String(index), file, file.name);
      });
    });
    formData.append('data', JSON.stringify(AddMeetingObj));
    return this.http.post(`${environment.apiUrl}/Meetings/AddMeeting`, formData);
  }
  EditMeetingAgendaItem(obj) {
    return this.http.post(`${environment.apiUrl}/meetingAgendaItems/EditMeetingAgendaItem`, obj);
  }

}
